import template from './topdata-contact-login-detail-details.html.twig';

const { Mixin, Classes } = Shopware;
const { Criteria } = Shopware.Data;

const DUPLICATE_EMAIL_CODE = 'VIOLATION::CUSTOMER_EMAIL_NOT_UNIQUE';

Shopware.Component.register('topdata-contact-login-detail-details', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        contact: {
            type: Object,
            required: true,
        },
        contactId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            isSaving: false,
            isSaveSuccessful: false,
            contactEmailError: null,
            customerAddresses: [],
            salutations: [],
        };
    },

    computed: {
        contactRepository() {
            return this.repositoryFactory.create('tdcl_customer_contact');
        },

        customerAddressRepository() {
            return this.repositoryFactory.create('customer_address');
        },

        salutationRepository() {
            return this.repositoryFactory.create('salutation');
        },

        salutationOptions() {
            return this.salutations.map((salutation) => ({
                value: salutation.id,
                label: salutation.translated.displayName,
            }));
        },

        addressOptions() {
            return this.customerAddresses.map((address) => ({
                value: address.id,
                label: this.getAddressLabel(address),
            }));
        },
    },

    created() {
        this.loadSalutations();
        this.loadCustomerAddresses();
    },

    methods: {
        loadSalutations() {
            const criteria = new Criteria();

            this.salutationRepository.search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.salutations = result;
                });
        },

        loadCustomerAddresses() {
            if (!this.contact.customerId) {
                return;
            }

            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('customerId', this.contact.customerId));

            this.customerAddressRepository.search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.customerAddresses = result;
                });
        },

        getAddressLabel(address) {
            if (!address) {
                return this.$tc('TopdataContactLoginSW6.admin.noAddress');
            }

            return `${address.street}, ${address.zipcode} ${address.city}`;
        },

        getCustomerLabel() {
            if (!this.contact.customer) {
                return '—';
            }

            const name = `${this.contact.customer.firstName} ${this.contact.customer.lastName}`.trim();

            return this.contact.customer.customerNumber
                ? `${name} (${this.contact.customer.customerNumber})`
                : name;
        },

        openCustomer() {
            if (!this.contact.customerId) {
                return;
            }

            this.$router.push({
                name: 'sw.customer.detail',
                params: { id: this.contact.customerId },
            });
        },

        validateContact() {
            const requiredFields = ['email', 'firstName', 'lastName'];

            const missingField = requiredFields.find((field) => !this.contact[field]);

            if (!missingField) {
                return true;
            }

            this.createNotificationError({
                message: this.$tc('TopdataContactLoginSW6.contactList.detail.requiredFieldsMissing'),
            });

            return false;
        },

        onSave() {
            if (!this.validateContact()) {
                return;
            }

            this.isSaving = true;
            this.contactEmailError = null;

            this.contactRepository.save(this.contact, Shopware.Context.api)
                .then(() => {
                    this.isSaveSuccessful = true;
                    this.contact.password = '';

                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactSaved'),
                    });
                })
                .catch((exception) => {
                    this.handleSaveError(exception);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        handleSaveError(exception) {
            const errors = exception && exception.response && exception.response.data
                ? exception.response.data.errors
                : [];

            const emailViolation = errors.find((error) => (
                error.code === DUPLICATE_EMAIL_CODE
                || (error.source && error.source.pointer === '/email')
            ));

            if (emailViolation) {
                this.contactEmailError = new Classes.ShopwareError({
                    code: DUPLICATE_EMAIL_CODE,
                    detail: this.$tc('TopdataContactLoginSW6.admin.contactEmailNotUnique'),
                });

                this.createNotificationError({
                    message: this.$tc('TopdataContactLoginSW6.admin.contactEmailNotUnique'),
                });

                return;
            }

            this.contactEmailError = null;

            this.createNotificationError({
                message: this.$tc('TopdataContactLoginSW6.admin.contactSaveError'),
            });
        },
    },
});
